



























































































































import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import { DataPointName, DateData } from '@front-app/hooks/DataDashboard/model';
import { ARIA_LABELS } from '@front-app/views/home/group/admin/dataDashboard';
import { DEFAULT_SORT_DIRECTION } from '@front-app/router/util/groupDataQuery';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import PremiumTooltip from '@front-app/modules/dataDashboards/components/PremiumTooltip.vue';
import { DataTableColumn, SortDirection } from './model';
import SimpleCard from '../cards/SimpleCard.vue';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		SimpleCard,
		CtaButton,
		PremiumTooltip,
	},
	props: {
		data: {
			type: Array as PropType<DateData[]>,
			required: true,
		},
		columns: {
			type: Object as PropType<DataTableColumn>,
			required: true,
		},
		sortBy: {
			type: String as PropType<DataPointName>,
			required: true,
		},
		sortDirection: {
			type: String as PropType<SortDirection>,
			required: true,
		},
		isEnhancedDashboard: Boolean,
	},
	setup(props) {
		const buttonAriaLabel = (col: DataPointName): string => {
			if (col !== props.sortBy) {
				return ARIA_LABELS[col][DEFAULT_SORT_DIRECTION];
			}
			const direction = props.sortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
			return ARIA_LABELS[col][direction];
		};
		const buttonIcon = (col: DataPointName): FontAwesomeIconProps => {
			if (col !== props.sortBy) {
				return {
					icon: 'sort',
					fixedWidth: true,
				};
			}
			if (props.sortDirection === SortDirection.ASC) {
				return {
					icon: 'sort-up',
					fixedWidth: true,
				};
			}
			return {
				icon: 'sort-down',
				fixedWidth: true,
			};
		};
		return {
			buttonIcon,
			buttonAriaLabel,
			DataPointName,
		};
	},
});
